/** Abre a busca global (Ctrl+K) de qualquer lugar — barra da página inicial, botões etc. */
export const searchEvents = new EventTarget();
export const openSearch = (text = '') => searchEvents.dispatchEvent(new CustomEvent('open', { detail: text }));
